export const customTags: Set<string> = new Set([
  'ACTION',
  'ALERT',
  'APPLICATION',
  'BACK',
  'BADGE',
  'BLOCK',
  'BORDER',
  'BOX',
  'CHECK',
  'CIRCLE',
  'COL',
  'COMMANDBAR',
  'CONT',
  'CONTAINER',
  'CONTENT',
  'CONTROLS',
  'COUNT',
  'CONTENT_WRAP',
  'COVER',
  'CYCLE',
  'DASHBOARD',
  'DECOR',
  'DECORATION',
  'DEMO_WRAP',
  'DEMOSPACE',
  'DETAIL',
  'DISTRIBUTION',
  'DOT',
  'EDGE',
  'EDGE_COVER',
  'ELASTIC',
  'ERRORMESSAGE',
  'GAP',
  'GRID',
  'GROUP',
  'HAMBURGER',
  'HOLDER',
  'HORIZONAL_WRAP',
  'ICON',
  'INFO',
  'INFOBAR',
  'INK',
  'ITEM',
  'LAYOUT',
  'LINE',
  'LOGIN',
  'LOGO',
  'LIST',
  'MEDIA',
  'MESSAGE',
  'NAME',
  'OVERLAY',
  'PANEL',
  'PLAYER',
  'PLAYLIST',
  'PICTURE',
  'PIE',
  'POINT',
  'ROW',
  'SEPARATOR',
  'SCROLLER',
  'SIDESGAP',
  'SPACE',
  'SUBTITLE',
  'SWITCH',
  'SWITCHABLE',
  'TAG',
  'TEST',
  'TEXT',
  'TEXT_LABEL',
  'TICK',
  'TIP',
  'TOOLBAR',
  'THUMB',
  'THUMBS',
  'VIEW',
  'WIDGET',
  'WRAP',
  'WRAPPER',
  'ZONE',
]);

declare global {
  namespace JSX {
    interface IntrinsicElements {
      [action: string]: any;
      [alert: string]: any;
      [application: string]: any;
      [badge: string]: any;
      [block: string]: any;
      [box: string]: any;
      [check: string]: any;
      [circle: string]: any;
      [col: string]: any;
      [cont: string]: any;
      [line: string]: any;
      [decor: string]: any;
      [ink: string]: any;
      [border: string]: any;
      [container: string]: any;
      [content_wrap: string]: any;
      [controls: string]: any;
      [count: string]: any;
      [cover: string]: any;
      [cycle: string]: any;
      [dashboard: string]: any;
      [decor: string]: any;
      [demo_wrap: string]: any;
      [demospace: string]: any;
      [detail: string]: any;
      [distribution: string]: any;
      [dot: string]: any;
      [elastic: string]: any;
      [gap: string]: any;
      [sidesGap: string]: any;
      [grid: string]: any;
      [group: string]: any;
      [hamburger: string]: any;
      [holder: string]: any;
      [horizonal_wrap: string]: any;
      [icon: string]: any;
      [info: string]: any;
      [infobar: string]: any;
      [item: string]: any;
      [layout: string]: any;
      [length: string]: any;
      [line: string]: any;
      [list: string]: any;
      [login: string]: any;
      [logo: string]: any;
      [media: string]: any;
      [message: string]: any;
      [monospace: string]: any;
      [name: string]: any;
      [overlay: string]: any;
      [panel: string]: any;
      [picture: string]: { rotate?: any };
      [pie: string]: any;
      [player: string]: any;
      [playlist: string]: any;
      [point: string]: any;
      [preline: string]: any;
      [row: string]: any;
      [scroller: string]: any;
      [separator: string]: { horizontal?: any };
      [size: string]: any;
      [space: string]: any;
      [span: string]: { large?: any };
      [subtitle: string]: any;
      // [switch: string]: any;
      [switchable: string]: any;
      [tag: string]: any;
      [test: string]: any;
      [text: string]: any;
      [tick: string]: any;
      [tip: string]: any;
      [toolbar: string]: { main?: any };
      [thumb: string]: any;
      [thumbs: string]: any;
      [zone: string]: any;
      [view: string]: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
      [wrap: string]: any;
      [wrapper: string]: any;
      [widget: string]: any;
    }
  }
}

const nativeToString = Object.prototype.toString;
// toString override added to prototype of Custom class
// eslint-disable-next-line
Object.prototype.toString = function () {
    const tag = this as HTMLElement;
    try {
        if (customTags.has(tag.tagName)) {
            return `[object ${tag.tagName}]`;
        }
    } catch {}

    return nativeToString.call(this);
};

declare module 'react' {
  interface Attributes {
    // extends React's HTMLAttributes
    dashboard?: string | boolean;
    classic?: string | boolean;
    checkbox?: string | boolean;
    simple?: string | boolean;
    minimal?: string | boolean;
    radio?: string | boolean;
    effect?: string;
    border?: string;
    form?: string;
    link?: string;
    light?: string | boolean;
    wrap?: string | boolean;
    top?: string;
    tiny?: string;
    fixed?: string;
    small?: string;
    mini?: string | boolean;
    medium?: string | boolean;
    large?: string | boolean;
    horizontal?: string;
    intro?: string;
    background?: string;
    space?: string | boolean;
    launcher?: string;
    backdrop?: string;
    resize?: string;
    main?: string;
    icon?: string | ReactElement;
    index?: string | number | boolean;
    ref?: any;
    options?: any;
    ellipsis?: string | boolean;
    view?: any;
    decoration?: string;
    accent?: any;
    vertical?: boolean;
    inputbox?: string;
    preline?: string;
    monospace?: string;
    // type?: string | DataType | UploadType;
    editable?: any;
    length?: any;
    // size?: any;
    middle?: any;
    fit?: any;
    shrink?: any;
  }
}
